import { C as Cart } from './cart-BEbKDMPu.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { N as Notyf } from './notyf-DIw0RvBj.js';
import './uniq-BDEfcc0N.js';

class ProductForm extends HTMLElement {
  #unsubscribers = [];
  #form = this.querySelector('form');
  #quantityInput = this.#form.querySelector('input[name="quantity"]');
  // Get all submit buttons that are part of the form
  #submitButtons = document.querySelectorAll(`button[form="${this.#form.getAttribute('id')}"]`);

  connectedCallback() {
    this.#form.addEventListener('submit', (event) => this.#onFormSubmit(event));

    this.#unsubscribers.push(
      PubSub.subscribe('variant:change', ({ id, data: { html } }) => {
        if (id !== this.dataset.productId) return;
        this.#toggleLoading(false);
        const productForm = html.querySelector('product-form').cloneNode(true);
        this.replaceWith(productForm);
      }),
      PubSub.subscribe('quantity:change', ({ quantity }) => {
        this.#quantityInput.value = quantity;
      }),
      PubSub.subscribe('variant:changing', ({ id }) => {
        if (id !== this.dataset.productId) return;
        this.#toggleLoading(true);
      })
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  async #onFormSubmit(event) {
    event.preventDefault();
    this.#toggleLoading(true);

    try {
      await Cart.add({ form: this.#form });
      PubSub.publish('dialog:open', { id: 'cart-drawer' });
    } catch (error) {
      this.#onError(error);
    } finally {
      this.#toggleLoading(false);
    }
  }

  /**
   * Toggle loading state on submit buttons
   * @param {boolean} loading
   */
  #toggleLoading(loading) {
    this.#submitButtons.forEach((button) => button.classList.toggle('loading', loading));
  }

  /**
   * Handle form error
   * @param {Error} error - The error object
   */
  #onError({ message }) {
    Notyf.error(message);
  }
}

customElements.define('product-form', ProductForm);
